<nts-loader [skipHeader]="false" [isVisible]="!url || actionInProgress"></nts-loader>
<nts-iframe #iframe *ngIf="url" [url]="url"></nts-iframe>
